import { IAdapterConfig } from '@care-portals/api-interfaces';

export const Adapters: IAdapterConfig = {
  oncall: {
    label: 'OnCall',
    functions: {
      upsertContact: {
        label: 'Upsert Contact',
        version: 1,
        params: [
          { label: 'Division Url', key: 'division', type: 'string' },
          { label: 'Provider Url', key: 'provider', type: 'string' },
          { label: 'Name', key: 'name', type: 'string' },
          { label: 'Sex', key: 'sex', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          { label: 'DOB', key: 'dob', type: 'string' },
          { label: 'Notes', key: 'notes', type: 'string' }
        ]
      },
      createAppointmentFromCrmAppointment: {
        pipelines: ['appointment'],
        label: 'Create Appointment',
        version: 1,
        params: [
          { label: 'Division Url', key: 'division', type: 'string' },
          { label: 'Provider Url', key: 'provider', type: 'string' }
        ]
      },
      formAssignmentWebhookFetchParticipant: {
        label: 'Webhook:From Assignment > Get Participant',
        version: 1,
        params: []
      },
      getOncallAppointmentFromWebhook: {
        label: 'Webhook: appointment_created > Get Appointment',
        version: 1
      },
      cancelAppointment: {
        label: 'Cancel Appointment',
        version: 1,
        params: [
          {
            label: 'Oncall Appointment ID/URL',
            key: 'appointmentId',
            type: 'string'
          },
          {
            label: 'Oncall Provider URL',
            key: 'providerUrl',
            type: 'string'
          }
        ]
      },
      updateAppointment: {
        label: 'Update Appointment',
        version: 1,
        params: [
          {
            label: 'OnCall ID/URL',
            key: 'oncallId',
            type: 'string'
          },
          {
            label: 'OnCall Provider URL',
            key: 'providerUrl',
            type: 'string'
          },
          {
            label: 'Duration',
            key: 'duration',
            type: 'string'
          },
          {
            label: 'Start Time',
            key: 'datetime',
            type: 'string'
          },
          {
            label: 'Careportals Appointment ID',
            key: 'appointmentId',
            type: 'string'
          },
          {
            label: 'CarePortals Service ID',
            key: 'serviceId',
            type: 'string'
          },
          {
            label: 'CarePortals Schedule ID',
            key: 'scheduleId',
            type: 'string'
          }
        ]
      },
      assignFormToContact: {
        label: 'Assign Form To Contact',
        version: 1,
        params: [
          {
            label: 'Form Url',
            key: 'formUrl',
            type: 'string'
          },
          {
            label: 'Contact Url',
            key: 'contactUrl',
            type: 'string'
          }
        ]
      }
    }
  },
  zoom: {
    label: 'Zoom',
    functions: {
      createMeetingMeetingFromAppointment: {
        version: 1
      },
      deleteAppointmentMeeting: {
        params: [{ label: 'Meeting ID path', key: 'idPath', type: 'string' }],
        version: 1
      }
    }
  },
  hubspot: {
    label: 'HubSpot',
    functions: {
      upsertContact: {
        version: 2,
        label: 'Upsert Contact',
        params: [
          { label: 'Email (required)', key: 'email', type: 'string' },
          { label: 'First Name', key: 'firstName', type: 'string' },
          { label: 'Last Name', key: 'lastName', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          { label: 'Address', key: 'address', type: 'string' },
          { label: 'City', key: 'city', type: 'string' },
          { label: 'Postal', key: 'postal', type: 'string' },
          { label: 'Country', key: 'country', type: 'string' },
          { label: 'Gender', key: 'gender', type: 'string' },
          { label: 'DOB', key: 'dob', type: 'string' },
          { label: 'Extra Properties', key: 'extraProperties', type: 'map' }
        ]
      },
      createContactFromCrmLead: {
        version: 1,
        pipelines: ['lead', 'customer']
      },
      createDealFromAppointment: {
        version: 1,
        params: [
          { label: 'Deal Stage', key: 'dealstage', type: 'string' },
          { label: 'Pipeline', key: 'pipeline', type: 'string' }
        ]
      }
    }
  },
  inputhealth: {
    label: 'InputHealth',
    functions: {
      createAppointment: {
        label: 'Create Appointment',
        pipelines: ['appointment'],
        version: 1,
        params: [{ label: 'Set locationId', key: 'locationId', type: 'string' }]
      },
      getAppointment: {
        label: 'Get Appointments',
        version: 2,
        params: [
          { label: 'Appointment ID', key: 'appointmentId', type: 'string' }
        ]
      },
      createPatient: {
        label: 'Create Patient',
        version: 2,
        pipelines: ['appointment', 'task'],
        params: [{ label: 'Lead', key: 'relatedToLead', type: 'string' }]
      }
    }
  },
  stripe: {
    label: 'Stripe',
    functions: {
      chargeUser: {
        label: 'Charge User',
        version: 1,
        params: [
          { key: 'email', label: 'Email', type: 'string' },
          { key: 'amount', label: 'Amount', type: 'string' },
          { key: 'currency', label: 'Currency', type: 'string' },
          { key: 'description', label: 'Description', type: 'string' },
          {
            key: 'resourceId',
            label: 'Resource ID (optional)',
            type: 'string'
          },
          {
            key: 'resourceType',
            label: 'Resource Type (optional)',
            type: 'string'
          }
        ]
      },
      createInvoice: {
        label: 'Create Invoice',
        version: 1,
        params: [
          { key: 'email', label: 'Email', type: 'string' },
          { key: 'amount', label: 'Amount', type: 'string' },
          { key: 'currency', label: 'Currency', type: 'string' },
          { key: 'description', label: 'Description', type: 'string' },
          {
            key: 'resourceId',
            label: 'Resource ID (optional)',
            type: 'string'
          },
          {
            key: 'metadata',
            label: 'Metadata (optional)',
            type: 'map'
          }
        ]
      },
      getPaymentIntent: {
        label: 'Get Payment',
        params: [
          { key: 'paymentIntentId', label: 'Payment ID', type: 'string' }
        ],
        version: 2
      },
      saveCardToUser: {
        label: 'Upsert User With Card',
        version: 1,
        params: [
          { key: 'emailPath', label: 'Email Path', type: 'string' },
          { key: 'tokenPath', label: 'Token Path', type: 'string' },
          {
            key: 'leadIdPath',
            label: 'Lead ID Path (optional)',
            type: 'string'
          }
        ]
      },
      webhooksConstructEvent: {
        label: 'Construct Payload',
        version: 1
      },
      retrieveCustomer: {
        label: 'Retrieve Customer',
        version: 1,
        params: [{ key: 'id', label: 'Customer ID', type: 'string' }]
      },
      capturePaymentIntent: {
        label: 'Capture Authorized Charge',
        version: 2,
        params: [{ key: 'chargeId', label: 'Charge ID', type: 'string' }]
      }
    }
  },
  sendgrid: {
    label: 'SendGrid',
    functions: {
      sendMessageFromAppointment: {
        pipelines: ['appointment'],
        version: 1,
        params: [
          { label: 'Template Id', key: 'templateId', type: 'string' },
          { label: 'From Email', key: 'fromEmail', type: 'email' },
          { label: 'Reply To Email', key: 'replyToEmail', type: 'email' }
        ]
      },
      sendMessage: {
        pipelines: ['appointment', 'task'],
        version: 1,
        params: [
          { label: 'Template Id', key: 'templateId', type: 'string' },
          { label: 'To Email:', key: 'toEmail', type: 'email' },
          { label: 'From Email', key: 'fromEmail', type: 'email' },
          { label: 'Reply To Email', key: 'replyToEmail', type: 'email' }
        ]
      }
    }
  },
  oscar: {
    label: 'Oscar',
    functions: {
      fetchProviderAppointmentsMonthly: {
        version: 1,
        params: [
          { key: 'providerId', type: 'number' },
          { key: 'year', type: 'number' },
          { key: 'month', type: 'number' }
        ]
      },
      fetchProviderAppointmentsDaily: {
        version: 1,
        params: [
          { key: 'providerId', type: 'number' },
          { key: 'todayOffset', type: 'number' }
        ]
      },
      createAppointmentFromCrmAppointment: {
        version: 1,
        params: [
          { key: 'demographicNo', type: 'string' },
          { key: 'providerNo', type: 'string' },
          { key: 'appointmentType', type: 'string' },
          { key: 'reason', type: 'string' }
        ]
      },
      createPatient: {
        version: 1,
        params: [
          { key: 'email', type: 'string' },
          { key: 'dob', type: 'string' },
          { key: 'firstName', type: 'string' },
          { key: 'lastName', type: 'string' },
          { key: 'gender', type: 'string' },
          { key: 'phone', type: 'string' },
          { key: 'emrId', type: 'string' },
          { key: 'hc_number', type: 'string' },
          { key: 'hc_type', type: 'string' },
          { key: 'hc_effectiveDate', type: 'string' },
          { key: 'hc_expiryDate', type: 'string' },
          { key: 'hc_version', type: 'string' },
          { key: 'notes', type: 'string' },
          { key: 'riskRating', type: 'string' },
          { key: 'source', type: 'string' },
          { key: 'address_address_1', type: 'string' },
          { key: 'address_address_1', type: 'string' },
          { key: 'address_city', type: 'string' },
          { key: 'address_country', type: 'string' },
          { key: 'address_postal', type: 'string' },
          { key: 'address_province', type: 'string' }
        ]
      },
      createPatientFromLead: {
        version: 1,
        pipelines: ['lead'],
        params: []
      }
    }
  },
  kroll: {
    label: 'Kroll',
    functions: {
      pushRxToQueue: {
        version: 1,
        params: [{ key: 'pathToPayload', type: 'string' }]
      }
    }
  },
  twilio: {
    label: 'Twilio',
    functions: {
      sendMessageFromAppointment: {
        version: 1,
        pipelines: ['appointment'],
        params: [
          { key: 'message', type: 'textarea' },
          { label: 'From Phone', key: 'fromPhone', type: 'tel' },
          {
            label: 'Hours to offset reservation time',
            key: 'timeZoneOffset',
            type: 'number'
          }
        ]
      },
      sendSMS: {
        version: 1,
        pipelines: ['appointment', 'task'],
        params: [
          { label: 'Message', key: 'message', type: 'textarea' },
          { label: 'To Phone', key: 'toPhone', type: 'tel' },
          { label: 'From Phone', key: 'fromPhone', type: 'tel' }
        ]
      }
    }
  },
  bigcommerce: {
    label: 'BigCommerce',
    functions: {
      // createCustomerFromLead: {
      //   params: [
      //     { key: 'message', type: 'string' },
      //     { key: 'fromPhone', type: 'string' }
      //   ]
      // },
      createOrderFromAppointment: {
        version: 1,
        params: []
      }
    }
  },
  klaviyo: {
    label: 'Klaviyo',
    functions: {
      sendEvent: {
        version: 1,
        params: [
          { label: 'Event Name', key: 'eventName', type: 'string' },
          { label: 'Email', key: 'email', type: 'string' },
          { label: 'CustomerId', key: 'customerId', type: 'string' },
          {
            label: 'Customer Properties',
            key: 'customerProperties',
            type: 'map'
          },
          { label: 'Properties', key: 'properties', type: 'map' }
        ]
      },
      subscribeToList: {
        version: 1,
        params: [
          { label: 'List Id', key: 'listId', type: 'string' },
          { label: 'Email', key: 'email', type: 'string' },
          {
            label: 'Accept Marketing',
            key: 'acceptMarketing',
            type: 'boolean'
          },
          { label: 'Source (optional)', key: 'source', type: 'string' },
          { label: 'Properties', key: 'properties', type: 'map' }
        ]
      },
      updateCustomer: {
        version: 1,
        params: [
          { label: 'Customer ID', key: 'customerId', type: 'string' },
          { label: 'Email', key: 'email', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          { label: 'First Name', key: 'firstName', type: 'string' },
          { label: 'Last Name', key: 'lastName', type: 'string' },
          { label: 'Properties', key: 'properties', type: 'map' }
        ]
      }
    }
  },
  beluga: {
    label: 'Beluga',
    functions: {
      createVisit: {
        version: 2,
        label: 'Create Visit',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      autoAssignPharmacy: {
        version: 2,
        label: 'Auto Assign Pharmacy',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      cancelVisit: {
        version: 2,
        label: 'Cancel Visit',
        pipelines: ['order'],
        params: [{ label: 'Master ID', key: 'masterId', type: 'string' }]
      },
      forwardPatientMessage: {
        version: 1,
        label: 'Forward Patient Message',
        pipelines: ['message'],
        params: []
      },
      getLabResults: {
        version: 2,
        label: 'Get Lab Results',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      submitLabResults: {
        version: 2,
        label: 'Submit Lab Results',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      refill: {
        version: 2,
        passPayload: true,
        label: 'Refill',
        pipelines: ['order'],
        params: []
      },
      loadDrugs: {
        version: 2,
        passPayload: true,
        label: 'Load Drugs From Beluga Dashboard If Not Exist',
        pipelines: ['prescription'],
        params: []
      },
      handleWebhook: {
        version: 2,
        passPayload: true,
        label: 'Handle Beluga Webhook',
        pipelines: ['webhook'],
        middlewareHandler: 'beluga',
        params: []
      },
      updateCustomerAddress: {
        version: 2,
        passPayload: true,
        label: 'Update Customer Address',
        pipelines: ['customer'],
        params: []
      },
      updateOrderAddress: {
        version: 2,
        passPayload: true,
        label: 'Update Order Shipping Address',
        pipelines: ['order'],
        params: []
      }
    }
  },
  curexaPharmacy: {
    label: 'Curexa Pharmacy',
    functions: {
      createOrder: {
        version: 1,
        label: 'Create Order',
        pipelines: ['order'],
        params: [
          // { label: 'Order ID', key: 'orderId', type: 'string' },
          // { label: 'Email', key: 'email', type: 'string' },
          // { label: 'Patient First Name', key: 'pFirstName', type: 'string' },
          // { label: 'Patient Last Name', key: 'pLastName', type: 'string' },
          // { label: 'Patient DOB', key: 'dob', type: 'string' },
          // { label: 'Prescription ID', key: 'prescriptionId', type: 'string' }
        ]
      },
      createOrderFromFulfill: {
        version: 1,
        label: 'Create Order From Fulfill',
        pipelines: ['prescription'],
        params: []
      },
      handleWebhook: {
        version: 1,
        label: 'Update Order Status from Curexa Status',
        pipelines: ['webhook'],
        params: []
      }
    }
  },
  pharmacyHub: {
    label: 'Pharmacy Hub',
    functions: {
      getStatusForOrder: {
        version: 2,
        label: 'Get Status for Order',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      getStatus: {
        version: 1,
        label: 'Get Status for All Orders',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      fulfillOrder: {
        version: 1,
        label: 'Fulfill Order',
        pipelines: ['order'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      refill: {
        version: 2,
        label: 'Refill',
        pipelines: ['order'],
        params: [
          { label: 'Older Order ID', key: 'oldOrderId', type: 'string' },
          { label: 'New Order ID', key: 'newOrderId', type: 'string' }
        ]
      },
      stopFulfillment: {
        version: 1,
        label: 'Stop Fulfillment',
        pipelines: ['order'],
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Rx ID', key: 'rxId', type: 'string' }
        ]
      },
      handleWebhook: {
        version: 2,
        passPayload: true,
        label: 'Update Order from Webhook',
        pipelines: ['webhook'],
        params: []
      }
    }
  },
  webhook: {
    label: 'Webhook',
    functions: {
      sendEvent: {
        label: 'Send Event',
        version: 1, // need to be careful with switching this to 2 as the json is not rendered on version 2
        params: [
          { label: 'Url', key: 'url', type: 'string' },
          {
            label: 'Method',
            key: 'method',
            type: 'select',
            options: ['post', 'put', 'patch', 'get', 'delete']
          },
          { label: 'Headers', key: 'headers', type: 'map' },
          { label: 'Query Params', key: 'queryParams', type: 'map' },
          { label: 'JSON Body', key: 'json', type: 'json' }
        ]
      },
      sendEventWithMapper: {
        label: 'Send Event (mapperFn)',
        version: 1, // need to be careful with switching this to version 2 as the mapperFn need payload and history separated
        params: [
          { label: 'Url', key: 'url', type: 'string' },
          {
            label: 'Method',
            key: 'method',
            type: 'select',
            options: ['post', 'put', 'patch', 'get', 'delete']
          },
          { label: 'Headers', key: 'headers', type: 'map' },
          { label: 'Query Params', key: 'queryParams', type: 'map' },
          {
            label: 'Body = function(payload, history):',
            key: 'mapperFnBody',
            type: 'textarea',
            placeholder:
              'return {}; // javascript statements must return json object'
          }
        ]
      }
    }
  },
  lifefile: {
    label: 'LifeFile',
    functions: {
      createOrder: {
        version: 2,
        label: 'Create Order',
        params: [
          { key: 'orderId', type: 'string', label: 'Order Id' },
          { key: 'generatePdf', type: 'boolean', label: 'Generate RX PDF' },
          { key: 'baseUrl', type: 'string', label: 'Base URL' },
          { key: 'username', type: 'string', label: 'Username' },
          { key: 'password', type: 'string', label: 'Password' },
          { key: 'practiceId', type: 'string', label: 'Practice Id' },
          { key: 'vendorId', type: 'string', label: 'Vendor Id' },
          { key: 'locationId', type: 'string', label: 'Location Id' },
          { key: 'networkId', type: 'string', label: 'Network Id' },
          { key: 'statusId', type: 'string', label: 'Status Id' },
          {
            key: 'shippingServiceId',
            type: 'string',
            label: 'Shipping Service Id'
          }
        ]
      },

      handleWebhook: {
        version: 1,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        params: []
      }
    }
  },
  mailchimp: {
    label: 'Mailchimp',
    functions: {
      createContact: {
        version: 2,
        label: 'Create Contact',
        params: [
          { label: 'Email (required)', key: 'email', type: 'string' },
          { label: 'First Name', key: 'firstName', type: 'string' },
          { label: 'Last Name', key: 'lastName', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          {
            label: 'Accept Marketing',
            key: 'acceptMarketing',
            type: 'boolean'
          },
          { label: 'DOB', key: 'dob', type: 'string' },
          { label: 'Address 1', key: 'address1', type: 'string' },
          { label: 'Address 2', key: 'address2', type: 'string' },
          { label: 'City', key: 'city', type: 'string' },
          { label: 'State', key: 'state', type: 'string' },
          { label: 'Zip', key: 'zip', type: 'string' },
          { label: 'Country', key: 'country', type: 'string' },
          { label: 'Properties', key: 'properties', type: 'map' }
        ]
      },
      addEvent: {
        version: 2,
        label: 'Add Event',
        params: [
          { label: 'Email', key: 'email', type: 'string' },
          { label: 'Event Name', key: 'eventName', type: 'string' },
          {
            label: 'Occurred At (optional)',
            key: 'occurredAt',
            type: 'string'
          },
          {
            label: 'Is Syncing (optional)',
            key: 'isSyncing',
            type: 'boolean'
          },
          { label: 'Properties', key: 'properties', type: 'map' }
        ]
      }
    }
  },
  attentive: {
    label: 'Attentive',
    functions: {
      subscribe: {
        version: 2,
        label: 'Subscribe',
        params: [
          { key: 'userEmail', type: 'string', label: 'Email' },
          { key: 'userPhone', type: 'string', label: 'Phone' },
          { key: 'userId', type: 'string', label: 'User Id' },
          { key: 'userFullName', type: 'string', label: 'Full Name' },
          {
            key: 'signUpSourceId',
            type: 'string',
            label: 'Sign Up Source Id'
          },
          {
            key: 'subscriptionType',
            type: 'string',
            label: 'Subscription Type'
          },
          {
            key: 'singleOptIn',
            type: 'boolean',
            label: 'Single Opt In (optional)'
          }
        ]
      },
      sendEvent: {
        version: 2,
        label: 'Send Event',
        params: [
          { key: 'type', type: 'string', label: 'Event Type' },
          { key: 'userEmail', type: 'string', label: 'Email' },
          { key: 'userPhone', type: 'string', label: 'Phone' },
          { key: 'userId', type: 'string', label: 'User Id' },
          { key: 'userFullName', type: 'string', label: 'Full Name' },
          {
            key: 'externalEventId',
            type: 'string',
            label: 'External Event Id (optional)'
          },
          {
            key: 'occurredAt',
            type: 'string',
            label: 'Occurred At (optional)'
          },
          { key: 'properties', type: 'map', label: 'Properties' }
        ]
      }
    }
  },
  persona: {
    label: 'Persona',
    functions: {
      handleWebhook: {
        version: 2,
        label: 'Handle Persona Webhook on ID Verification',
        pipelines: ['webhook'],
        params: [
          {
            key: 'firstNameKey',
            type: 'string',
            label: 'First Name Field Key',
            placeholder: 'Optional'
          },
          {
            key: 'lastNameKey',
            type: 'string',
            label: 'Last Name Field Key',
            placeholder: 'Optional'
          },
          {
            key: 'birthdateKey',
            type: 'string',
            label: 'DOB Field Key',
            placeholder: 'Optional'
          },
          {
            key: 'expirationDateKey',
            type: 'string',
            label: 'Expiration Date Field Key',
            placeholder: 'Optional'
          }
        ],
        passPayload: true
      }
    }
  },
  dosespot: {
    label: 'DoseSpot',
    functions: {
      createPatient: {
        version: 2,
        label: 'Create Patient',
        params: [
          { key: 'id', type: 'string', label: 'ID (careportals _id) *' },
          { key: 'firstName', type: 'string', label: 'First Name *' },
          { key: 'lastName', type: 'string', label: 'Last Name *' },
          { key: 'dob', type: 'string', label: 'Date of Birth *' },
          { key: 'gender', type: 'string', label: 'Gender *' },
          { key: 'email', type: 'string', label: 'Email *' },
          { key: 'address1', type: 'string', label: 'Address 1 *' },
          { key: 'address2', type: 'string', label: 'Address 2 (optional)' },
          { key: 'city', type: 'string', label: 'City *' },
          { key: 'state', type: 'string', label: 'State *' },
          { key: 'zipCode', type: 'string', label: 'Zip Code *' },
          { key: 'phone', type: 'string', label: 'Phone *' }
        ],
        passPayload: true
      },
      updatePatient: {
        version: 2,
        label: 'Update Patient Demographics',
        params: [
          {
            key: 'dosespotPatientId',
            type: 'string',
            label: 'DoseSpot Patient ID *'
          },
          { key: 'firstName', type: 'string', label: 'First Name' },
          { key: 'lastName', type: 'string', label: 'Last Name' },
          { key: 'dob', type: 'string', label: 'Date of Birth' },
          { key: 'gender', type: 'string', label: 'Gender' },
          { key: 'email', type: 'string', label: 'Email' },
          { key: 'address1', type: 'string', label: 'Address 1' },
          { key: 'address2', type: 'string', label: 'Address 2' },
          { key: 'city', type: 'string', label: 'City' },
          { key: 'state', type: 'string', label: 'State' },
          { key: 'zipCode', type: 'string', label: 'Zip Code' },
          { key: 'phone', type: 'string', label: 'Phone' }
        ],
        passPayload: true
      },
      addPatientPharmacy: {
        version: 2,
        label: 'Add Patient Pharmacy',
        params: [
          { key: 'patientId', type: 'string', label: 'DoseSpot Patient ID' },
          { key: 'pharmacyId', type: 'string', label: 'Pharmacy ID' }
        ],
        passPayload: true
      },
      submitDoseSpotAllergies: {
        version: 2,
        label: 'Submit DoseSpot Allergies',
        params: [{ label: 'Customer ID', key: 'customerId', type: 'string' }]
      },
      handleWebhook: {
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        params: [],
        passPayload: true
      }
    }
  },
  gogomeds: {
    label: 'GoGoMeds',
    functions: {
      createOrder: {
        version: 2,
        label: 'Create Order',
        params: [{ key: 'orderId', type: 'string', label: 'Order Id' }]
      },
      handleWebhook: {
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        params: [],
        passPayload: true
      }
    }
  },
  pharmetika: {
    label: 'Pharmetika',
    functions: {
      createOrder: {
        version: 2,
        label: 'Create Order',
        params: [
          { key: 'orderId', type: 'string', label: 'Order Id' },
          { key: 'practitionerId', type: 'string', label: 'Practitioner Id' },
          { key: 'clinicId', type: 'string', label: 'Clinic Id' },
          { key: 'baseUrl', type: 'string', label: 'Base URL' },
          { key: 'username', type: 'string', label: 'Username' },
          { key: 'password', type: 'string', label: 'Password' }
        ]
      },
      handleWebhook: {
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        params: [],
        passPayload: true
      }
    }
  },
  shipstation: {
    label: 'ShipStation',
    functions: {
      updateOrderAddress: {
        version: 2,
        label: 'Update Order Address',
        params: [{ key: 'orderId', type: 'string', label: 'Order Id' }]
      }
    }
  },
  healthie: {
    label: 'Healthie',
    functions: {
      getPatient: {
        version: 2,
        label: 'Get Patient',
        params: [{ key: 'patientId', type: 'string', label: 'Patient Id' }]
      },
      createPatient: {
        version: 2,
        label: 'Create Patient',
        params: [
          { key: 'firstName', type: 'string', label: 'First Name' },
          { key: 'lastName', type: 'string', label: 'Last Name' },
          { key: 'email', type: 'string', label: 'Email' },
          { key: 'phone', type: 'string', label: 'Phone' },
          { key: 'dob', type: 'string', label: 'DOB' },
          { key: 'gender', type: 'string', label: 'Gender' },
          { key: 'line1', type: 'string', label: 'Address Line 1' },
          { key: 'line2', type: 'string', label: 'Address Line 2' },
          { key: 'city', type: 'string', label: 'City' },
          { key: 'state', type: 'string', label: 'State' },
          { key: 'zip', type: 'string', label: 'Zip' },
          { key: 'npi', type: 'string', label: 'NPI' },
          {
            key: 'additionalRecordIdentifier',
            type: 'string',
            label: 'Additional Record Identifier'
          },
          { key: 'userGroupId', type: 'string', label: 'User Group Id' },
          { key: 'skipEmail', type: 'boolean', label: 'Skip Email' },
          {
            key: 'dontSendWelcome',
            type: 'boolean',
            label: "Don't Send Welcome"
          },
          { key: 'metadata', type: 'map', label: 'Metadata' }
        ]
      },
      updatePatient: {
        version: 2,
        label: 'Update Patient',
        params: [
          { key: 'id', type: 'string', label: 'Patient Id' },
          { key: 'firstName', type: 'string', label: 'First Name' },
          { key: 'lastName', type: 'string', label: 'Last Name' },
          { key: 'email', type: 'string', label: 'Email' },
          { key: 'phone', type: 'string', label: 'Phone' },
          { key: 'dob', type: 'string', label: 'DOB' },
          { key: 'gender', type: 'string', label: 'Gender' },
          { key: 'line1', type: 'string', label: 'Address Line 1' },
          { key: 'line2', type: 'string', label: 'Address Line 2' },
          { key: 'city', type: 'string', label: 'City' },
          { key: 'state', type: 'string', label: 'State' },
          { key: 'zip', type: 'string', label: 'Zip' },
          {
            key: 'additionalRecordIdentifier',
            type: 'string',
            label: 'Additional Record Identifier'
          },
          { key: 'height', type: 'number', label: 'Height' }
        ]
      },
      createDocument: {
        version: 2,
        label: 'Create Document',
        params: [
          { key: 'patientId', type: 'string', label: 'Patient Id' },
          { key: 'documentBase64', type: 'string', label: 'Document Base64' },
          { key: 'documentName', type: 'string', label: 'Document Name' }
        ]
      },
      updatePatientMetrics: {
        version: 2,
        label: 'Update Patient Metrics',
        params: [
          { key: 'patientId', type: 'string', label: 'Patient Id' },
          {
            key: 'category',
            type: 'string',
            label: 'Category (Weight or A1C)'
          },
          { key: 'metricStatus', type: 'string', label: 'Metric Status' }
        ]
      },
      handleTestosteroneIntakeFrom: {
        label: 'Handle Testosterone Intake From',
        version: 2,
        params: [
          { label: 'Questionnaire ID', key: 'questionnaireId', type: 'string' }
        ]
      }
    }
  },
  ringCentral: {
    label: 'RingCentral',
    functions: {
      handleWebhook: {
        version: 2,
        label: 'Handle RingCentral Webhook and Download Fax (All-in-One)',
        pipelines: ['webhook'],
        params: [],
        passPayload: true
      }
    }
  },
  llamaIndex: {
    label: 'LlamaIndex',
    functions: {
      startExtractionJob: {
        version: 2,
        label: 'Extract Fax (with Webhook)',
        params: [
          { key: 'faxId', type: 'string', label: 'Fax Id' },
          { key: 'fileName', type: 'string', label: 'File Name' },
          { key: 'webhookUrl', type: 'string', label: 'Webhook URL' }
        ],
        passPayload: true
      },
      processLabResultWebhook: {
        version: 2,
        label: 'Process Lab Result Webhook',
        params: [],
        passPayload: true
      }
    }
  }
};
